module.exports = __webpack_public_path__ + "static/img/bcg_unit4.c1f252d3.png";